export default {
  seatlistsGetter(state) {
    return state.seatLists;
  },
}